import { render } from "./ApproveBox.vue?vue&type=template&id=d45aafb6&scoped=true&ts=true"
import script from "./ApproveBox.vue?vue&type=script&lang=ts"
export * from "./ApproveBox.vue?vue&type=script&lang=ts"

import "./ApproveBox.vue?vue&type=style&index=0&id=d45aafb6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45aafb6"]])

export default __exports__